<template>
    <div>
        <!-- <a-spin :spinning="spinning" class="spin-box" :tip="$t('spin.text')"> -->
            <template v-if="!dataType">
                <template v-if="current == 0">
                    <div class="box" :class="$vuetify.theme.dark ? 'box-d': ''">
                        <div class="list">
                            <v-row class="px-2 ma-0" v-if="showIosCode">
                                <v-col cols="12" md="12" style="padding:0;">
                                    <div>{{$t('account.dynamic.codeTitle')}} </div>
                                </v-col>
                                <v-col cols="12" md="12" >
                                    <div style="margin-bottom: 20px">{{$t('account.dynamic.newVersion')}}</div>
                                </v-col>
                                <v-col cols="12" md="12" style="padding:0;">
                                    <div class="download-code">
                                        <div class="code-box" :class="$vuetify.theme.dark ? 'code-box-d': ''" ref="iosCode"></div>
                                    </div>
                                </v-col>
                            </v-row>
                            <v-row class="px-2 ma-0" v-else>
                                <v-col cols="12" md="12" >
                                    <div class="text">{{$t('account.dynamic.comingSoon')}}</div>
                                </v-col>
                            </v-row>
                        </div>
                    </div>
                    <div class="app-d" :class="$vuetify.theme.dark ? 'app-d-dark': ''">{{$t('account.dynamic.app')}}<a href="javascript:" @click="addFun" style="color:#5066e0;">{{$t('account.dynamic.code')}}</a></div>
                    <v-row no-gutters>
                        <v-col cols="12" md="12" class="btn-group ">
                            <v-btn small outlined @click="close">{{$t('btn.close')}}</v-btn>
                        </v-col>
                    </v-row>
                </template>
                <template v-else>
                    <div class="two-box" :class="$vuetify.theme.dark ? 'two-box-d': ''">
                        <v-row class="px-2 ma-0">
                            <v-col cols="12" md="12" style="padding:0;">
                                <div>{{$t('account.dynamic.appCode')}}</div>
                            </v-col>
                            <v-col cols="12" md="12" style="padding:0;">
                                <div>{{$t('account.dynamic.activateCode')}}</div>
                            </v-col>
                            <v-col cols="12" md="12" style="padding:0;">
                                <div class="code" :class="$vuetify.theme.dark ? 'code-d': ''" v-if="codeUrl" ref="qrCodeUrl"></div>
                            </v-col>
                            <v-col cols="12" md="12" style="padding:0;">
                                <div>
                                    {{$t('account.dynamic.app2')}}
                                    <a href="javascript:" @click="downFunc" style="color:#5066e0">{{$t('account.dynamic.downloadCode')}}</a>
                                </div>
                            </v-col>
                        </v-row>
                    </div>
                    <div class="input-box">
                        <v-row class="px-2 ma-0">
                            <v-col cols="5" md="5" lg="5" xl="5" sm="7" style="padding:0;text-align: right;line-height: 40px;">
                                <div class="label">{{$t('account.dynamic.dynamicPwd')}}</div>
                            </v-col>
                            <!-- <v-spacer></v-spacer> -->
                            <v-col cols="7" md="4" lg="4" xl="4" sm="5" style="padding:0;">
                                <v-text-field
                                    style="font-size:12px;"
                                    v-model="codeToken"
                                    outlined
                                    dense
                                    :placeholder="$t('account.dynamic.placeholder')"
                                    hide-details="auto"
                                    class="mb-6"
                                >
                                </v-text-field>
                            </v-col>
                        </v-row>
                    </div>
                    <v-col cols="12" md="12" style="padding:0;">
                        <div style="color: red;margin: 0 auto;font-size:13px;text-align:center;">{{$t('account.dynamic.tip')}}</div>
                    </v-col>
                    <v-row no-gutters class="btn-group two-btn-group">
                        <v-col cols="12" sm="12">
                            <v-btn small color="primary" @click="subFun">{{$t('account.dynamic.subBtn')}}</v-btn>
                            <v-btn small outlined class="close_btn" @click="close">{{$t('btn.close')}}</v-btn>
                        </v-col>
                    </v-row>
                </template>
            </template>
            <template v-else>
                <v-col class="title"  :class="$vuetify.theme.dark ? '': 'title-l'" cols="12" >
                    {{$t('account.dynamic.safetyVerification')}}
                </v-col>
                <v-form
                    ref="dynamicForm"
                    v-model="valid"
                    class="form-box formStyle">
                    <v-text-field
                        outlined
                        disabled
                        dense
                        :value="dataList.mobile"
                        :label="$t('account.pghoess')"
                        hide-details="auto"
                        class="mb-6"
                    ></v-text-field>
                    <v-row no-gutters>
                        <v-col cols="8" md="8" lg="8" xl="8" sm="12">
                            <v-text-field
                                v-model="form.code"
                                outlined
                                required
                                dense
                                :disabled="pushKey"
                                :rules="dynamicFormRule.code"
                                :label="$t('account.code')"
                                :placeholder="$t('account.codePlaceholder')"
                                @keyup="(v) =>(form.code = v.target.value.replace(/[^\d]/g,''))"
                                hide-details="auto"
                                class="mb-6"
                            ></v-text-field>
                        </v-col>
                        <v-spacer></v-spacer>
                        <v-col cols="3" md="3" lg="3" xl="3" sm="12" class="code-box  ml-1 d-flex justify-end align-baseline" :class="codeText == $t('account.getCode')?'cursor-pointer':'text'" @click="getCode">
                            <v-btn small :disabled="pushKey"  outlined v-if="codeText == $t('account.getCode')" color="primary" min-height="40" style="width:118%">{{codeText}}</v-btn>
                            <v-btn small :disabled="pushKey" outlined v-else style="width:100%"   min-height="40">{{codeText+'s'}}</v-btn>
                        </v-col>
                    </v-row>
                        <!-- <a-form-model-item label="动态口令" prop="otp">
                            <a-input class="code-btn" v-model="form.otp" placeholder="请输入OTP动态口令">
                                <a-button class="get-code" type="link" @click="getOtp" slot="addonAfter">{{optText}}</a-button>
                            </a-input>
                        </a-form-model-item> -->
                        <v-row no-gutters>
                            <v-col cols="12" sm="12" class="mb-4 mt-2">
                                <v-btn small color="primary" @click="onSubmit">{{$t('btn.submit')}}</v-btn>
                                <v-btn small class="close_btn" outlined @click="close">{{$t('btn.close')}}</v-btn>
                            </v-col>
                        </v-row>
                </v-form>
            </template>
        <!-- </a-spin> -->
    </div>
</template>

<script>
import { getMobileTokenActiveData, smsReset, resetMobileToken,codeDownload} from "@/api/index";
import store from '@/store'
import QRCode from 'qrcodejs2'
export default {
    data() {
        return {
            valid: false,
            form: {},
            rules: {
                code: [
                    { required: true, message: this.$t('account.codePlaceholder'), trigger: 'blur' },
                    { pattern: /^[0-9]{6}$/, message: this.$t('account.code6') }
                ],
            },
            dynamicFormRule:
                {
                    code: [
                        v => !!v || this.$t('account.codePlaceholder'),
                        v => (/^[0-9]{6}$/.test(v)) || this.$t('account.code6')
                    ],
                },
            codeText: this.$t('account.getCode'),
            optText: this.$t('push.text'),
            current: 0,
            codeToken: null,
            // codeTt: '离线二维码',
            codeUrl: false,
            pushKey: false,
            spinning: false,
            showIosCode: true,
            // showAndroidCode: true,
            // codeStatus: null,
            // dynamicStatus: false
        };
    },
    props: {
        dataType: Boolean,
        dataList: Object
    },
    mounted() {
        if (this.dataType) {
            this.$root.eventHub.$on('handleCancel4', ()=> {
                this.$refs.dynamicForm.resetValidation();
                this.$root.eventHub.$off("handleCancel4")
            })
        } else {
            // if(this.codeStatus) {
            //     clearInterval(this.codeStatus)
            // }
            this.addFun()
            // this.getQRCode()
        }
    },
    methods: {
        onSubmit() {
            if(this.$refs.dynamicForm.validate()){
                resetMobileToken({
                    code: this.form.code,
                    // phonesn: this.form.phone,
                    // otp: this.form.otp
                }).then(res=> {
                    if (res.code == this.$GLOBA.StatusOK) {
                        store.dispatch('snackbar/openSnackbar',{
                            snackbarText: res.message,
                            colorType: 'success'
                        })
                        this.$emit("onSubmit")
                    }else{
                        store.dispatch('snackbar/openSnackbar',{
                            snackbarText: res.message,
                            colorType: 'error'
                        })
                    }
                })
            }else{
                return false;
            }
        },
        close() {
            this.$emit("close")
        },
        getCode() {
            // let list = ['phone']
            // let num = 0
            // this.$refs.dynamicForm.validateField(list, valid => {
            //     if (!valid) {
            //         num ++
            //     }
            // })
            // 1:注册短信，2:绑定手机短信，4:修改手机号码短信，3:忘记密码短信，5:登录短信，6:重置OTP短信，7:认证短信
            if(this.codeText == this.$t('account.getCode')) {
                this.spinning = true
                let params = {
                    // phonesn: this.form.phone,
                    smsType: this.$getSmsModel('dynamic')
                }
                smsReset(params).then(res=> {
                    this.spinning = false
                    if (res.code == this.$GLOBA.StatusOK) {
                        store.dispatch('snackbar/openSnackbar',{
                            snackbarText: res.message,
                            colorType: 'success'
                        })
                        this.codeText = 60
                        let timer = setInterval(()=>{
                            this.codeText--
                            if(this.codeText <= 0) {
                                clearInterval(timer)
                                this.codeText = this.$t('account.getCode')
                            }
                        },1000)
                    }else{
                        store.dispatch('snackbar/openSnackbar',{
                            snackbarText: res.message,
                            colorType: 'error'
                        })
                    }
                }).catch(err=> {
                    this.spinning = false
                })
            }
        },
        downFunc(){
            this.getQRCode()
            this.codeUrl = false
            this.current = 0;
            this.$refs.qrCodeUrl.innerHTML = ""
        },
        addFun() {
            this.codeUrl = true
            this.current = 1;
            let param = {
                type:this.codeTt == this.$t('account.offlineCode') ? "on" : "off"
            }
            // 设置二维码
            getMobileTokenActiveData(param).then(res=> {
                if (res.code == this.$GLOBA.StatusOK) {
                    let qrcodeCreater = new QRCode(this.$refs.qrCodeUrl, {
                        text: res.data.activecode,
                        colorDark: '#000000',
                        colorLight: '#ffffff',
                        width: 200,
                        height: 200,
                        typeNumber: 4,
                        correctLevel: QRCode.CorrectLevel.L
                    })
                    qrcodeCreater._el.title = ""
                    // this.getStatus('created')
                }else{
                    store.dispatch('snackbar/openSnackbar',{
                        snackbarText: res.message,
                        colorType: 'error'
                    })
                }
            })
        },
        subFun() {
                this.$emit("subFun", this.codeToken)
        },
        getQRCode() {
            codeDownload().then(res=> {
                if (res.code == this.$GLOBA.StatusOK) {
                    if (res.data.android) {
                        this.showIosCode = true
                        let qrcodeCreaterIos = new QRCode(this.$refs.iosCode, {
                            text: res.data.android,
                            colorDark: '#000000',
                            colorLight: '#ffffff',
                            width: 200,
                            height: 200,
                            typeNumber: 4,
                            correctLevel: QRCode.CorrectLevel.L
                        })
                        qrcodeCreaterIos._el.title = ""
                    } else {
                        this.showIosCode = false
                    }

                }
            })
        }
    },
};
</script>

<style scoped lang="scss">
::v-deep .ant-input-group-addon {
    min-width: 93px;
    background: none;
}
.get-code {
    border: 0;
    height: 100%;
    // cursor: pointer;
    // color: #337DF7;
}
// .tip {
//     font-size: 14px;
//     margin-top: 20px;
//     color: #e4393c;
//     text-align: center;
// }
.title {
    font-size: 18px;
    font-weight: bold;
    text-align: center;
    margin: 10px 0 20px 0;
}
.title-l {
    color: #333;
}
.code-btn ::v-deep .ant-input {
    border-right: 0;
}
.ant-steps {
    width: 60%;
    margin: 20px auto 100px;
}
.box {
    display: flex;
    font-size: 14px;
    color: #333;
    padding-top: 16px;
    .list {
        flex: 1;
        text-align: center;
        .d-text {
            margin: 5px 0 50px;
        }
        .download-code {
            display: flex;
            justify-content: center;
            margin-bottom: 20px;
            .code-box {
                background: #FFFFFF;
                padding: 21px;
                box-shadow: 0px 0px 14px 1px rgba(0, 0, 0, 0.16);
            }
            .code-box-d {
                background: #3B355A;
            }
        }
        .text {
            font-weight: bold;
            font-size: 18px;
        }
    }
}
.box-d {
    color: rgba(231, 227, 252, 0.68) !important;
}
.btn-group {
    text-align: center;
    margin-bottom: 20px;
}
.two-box {
    // width: 480px;
    background: #FFFFFF;
    // border: 1px solid #d9d9d9;
    margin: 0 auto;
    padding: 16px 0 20px;
    font-size: 14px;
    text-align: center;
    color: #333;
    ::v-deep .code {
        margin: 30px auto 20px;
        display: flex;
        justify-content: center;
        width: 250px;
        max-width: 250px;
        height: 250px;
        background: #FFFFFF;
        padding: 21px;
        box-shadow: 0px 0px 14px 1px rgba(0, 0, 0, 0.16);

        img{
            width: 100%;
             max-width: 200px;
             min-width: 200px;
        }

        // border: 1px solid red;
        // position: relative;
        // .qr-success-text {
        //     position: absolute;
        //     top: 0;
        //     left: 50%;
        //     transform: translateX(-50%);
        //     width: 300px;
        //     height: 300px;
        //     background-color: rgba(255,255,255, 0.9);
        //     display: flex;
        //     align-items: center;
        //     justify-content: center;
        //     flex-direction: column;
        //     font-size: 16px;
        //     text-align: center;
        //     font-weight: bold;
        //     .s-title {
        //         font-size: 18px;
        //         margin-bottom: 3px;
        //         margin-top: 20px;
        //     }
        // }
    }
    .code-d {
        // background: #3B355A;
    }
}
.two-box-d {
    background: none;
    color: rgba(231, 227, 252, 0.68) !important;
}
.two-btn-group {
    margin-top: 20px;
}
.input-box{
    margin: 0px auto 10px auto;

    display: flex;
    align-items: center;
    justify-content: center;
    .label {
        font-size: 14px;
    }
    .ant-input {
        width: 230px;
    }
}
::v-deep{
    .ant-btn-link{
        color: #5066e0;
    }
}
// .code-text {
//     color: #1890ff;
//     cursor: pointer;
// }
.app-d {
    text-align: center;
    // font-size: 16px;
    margin-bottom: 20px;
    color: #333;
}
.app-d-dark {
    color: rgba(231, 227, 252, 0.68) !important;
}
.formStyle{
    width: 70%;
    margin-left: 15%;
}
::v-deep .row {
    align-items: start !important;
}
.close_btn{
    margin-left: 10px;
}
.code-box ::v-deep {
  .v-btn.theme--dark {
    border-color: rgba(231, 227, 252, 0.28) !important;
    .v-btn__content{
      color:rgba(231, 227, 252, 0.67);
    }
  }
}

@media screen and (min-width: 320px) and (max-width: 480px){
    .close_btn{
        margin-left: 6px;
    }
    ::v-deep {
        .v-text-field.v-text-field--enclosed .v-text-field__details{
            padding: 0;
        }
    }
    .formStyle{
        width: 106%;
        margin-left: -3%;
    }
}
</style>
